import axios from 'axios'
import { ResponseObject } from '../../../models'

const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export async function createCrewAssignment(data: any) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/CrewAssignment/create`, data)
}

export async function updateLeaderCrewAssignment(data: any) {
  return await axios.put<ResponseObject<any>>(`${BASEURL}/CrewAssignment/updateLeader`, data)
}

export async function getAllSquadMembers() {
  return await axios.get<ResponseObject<{ members: any[] }>>(`${BASEURL}/CrewAssignment/getAllSquadMembers`)
}
